import { render, staticRenderFns } from "./appGroupManage.vue?vue&type=template&id=6654aec0&scoped=true&"
import script from "./appGroupManage.vue?vue&type=script&lang=js&"
export * from "./appGroupManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6654aec0",
  null
  
)

export default component.exports